import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content"
  }, [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "100px",
      "label-position": "top",
      size: "mini"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    staticClass: "form-item form-in-line-item",
    attrs: {
      prop: "name",
      label: "模板名称"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.isInCorrespondence,
      placeholder: "请输入模板名称"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1)], 1), !_vm.confirmId ? [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      label: "模板说明"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      disabled: _vm.isInCorrespondence,
      placeholder: "请输入模板说明"
    },
    model: {
      value: _vm.form.desc,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "desc", $$v);
      },
      expression: "form.desc"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      prop: "revise",
      label: "修订记录"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      disabled: _vm.isInCorrespondence,
      placeholder: "请输入修订记录"
    },
    model: {
      value: _vm.form.revise,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "revise", $$v);
      },
      expression: "form.revise"
    }
  })], 1)], 1)], 1)] : _vm._e(), _vm.id && !_vm.isCopy && !_vm.isInCorrespondence ? [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-item form-in-line-item",
    attrs: {
      label: "创建日期"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("date")(_vm.form.creareDate)) + " ")])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      label: "最后维护日期"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("date")(_vm.form.updateDate)) + " ")])], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-item form-in-line-item",
    attrs: {
      label: "模板所属"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.belong) + " ")])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-item form-in-line-item",
    attrs: {
      label: "模板来源"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.from) + " ")])], 1)], 1)] : _vm._e(), (!_vm.id || _vm.isCopy) && !_vm.isInCorrespondence ? _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-item enable",
    attrs: {
      label: "租户启用"
    }
  }, [_c("el-radio-group", {
    attrs: {
      disabled: _vm.isCopy
    },
    model: {
      value: _vm.form.use,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "use", $$v);
      },
      expression: "form.use"
    }
  }, [_c("el-radio", {
    attrs: {
      label: true
    }
  }, [_vm._v("是")]), _c("el-radio", {
    attrs: {
      label: false
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-item form-in-line-item",
    attrs: {
      prop: "CTShare",
      label: "共享意愿"
    }
  }, [_c("el-radio-group", {
    attrs: {
      disabled: _vm.isCopy
    },
    model: {
      value: _vm.form.share,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "share", $$v);
      },
      expression: "form.share"
    }
  }, [_c("el-radio", {
    attrs: {
      label: true
    }
  }, [_vm._v("是")]), _c("el-radio", {
    attrs: {
      label: false
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "template-content-wrap"
  }, [_c("div", {
    staticClass: "template-content"
  }, [_c("el-form-item", {
    staticClass: "form-item form-in-line-item height app-editor-form-item",
    attrs: {
      prop: "editorVal",
      label: "函证内容"
    }
  }, [_c("editor", {
    staticClass: "my-editor",
    attrs: {
      "tool-fixed": _vm.toolFixed,
      "is-document": true,
      disabled: _vm.isCopy || _vm.isPreView,
      "default-val": _vm.defaultEditorVal
    },
    on: {
      change: _vm.updateEditor
    }
  })], 1)], 1)]), _vm.id ? _c("div", {
    staticClass: "table"
  }, [_c("p", [_vm._v("函证模板元素 "), !_vm.isCopy ? _c("el-button", {
    attrs: {
      disabled: _vm.isPreView,
      type: "text",
      icon: "el-icon-circle-plus-outline",
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.create("create");
      }
    }
  }) : _vm._e()], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading || _vm.paramLoading,
      expression: "loading || paramLoading"
    }],
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      border: "",
      data: _vm.currentTableData,
      size: "mini",
      stripe: "",
      "max-height": "800"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "元素名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.name) + " ")];
      }
    }], null, false, 2507105690)
  }), _c("el-table-column", {
    attrs: {
      label: "元素类型",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.type) + " ")];
      }
    }], null, false, 2563026053)
  }), _c("el-table-column", {
    attrs: {
      label: "表格表头"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.header) + " ")];
      }
    }], null, false, 542845282)
  }), _vm.isInCorrespondence ? [_c("el-table-column", {
    attrs: {
      label: "元素数据",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type === "表格" || scope.row.type === "导入" ? _c("div", [_c("el-popover", {
          attrs: {
            placement: "top-start",
            width: "400",
            trigger: "hover"
          }
        }, [_c("div", {
          staticClass: "params-table"
        }, [_c("table", {
          attrs: {
            width: "100%"
          }
        }, [_c("tr", _vm._l(_vm.getTableHeaders(scope.row), function (th, index) {
          return _c("th", {
            key: index
          }, [_vm._v(_vm._s(th))]);
        }), 0), _c("tr", _vm._l(_vm.getTableParams(scope.row.data), function (td, index) {
          return _c("td", {
            key: index
          }, [_vm._v(_vm._s(td))]);
        }), 0)])]), _c("i", {
          staticClass: "el-icon-info",
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        })])], 1) : _c("span", [_vm._v(_vm._s(scope.row.data))])];
      }
    }], null, false, 1566594337)
  }), _c("el-table-column", {
    attrs: {
      label: "报表科目",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.account) + " ")];
      }
    }], null, false, 4056155100)
  }), _c("el-table-column", {
    attrs: {
      label: "科目余额",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.amount) + " ")];
      }
    }], null, false, 1457177553)
  }), _c("el-table-column", {
    attrs: {
      label: "截止日期",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("date")(scope.row.perior, "yyyy-MM-dd")) + " ")];
      }
    }], null, false, 468987279)
  })] : _vm._e(), !_vm.isCopy ? _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "60",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return !_vm.onlyRead ? [_c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            icon: "el-icon-edit",
            disabled: _vm.isPreView,
            title: "编辑"
          },
          on: {
            click: function click($event) {
              return _vm.create("edit", scope.row, scope.$index);
            }
          }
        }), _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            disabled: _vm.isPreView,
            title: "删除",
            icon: "el-icon-delete"
          },
          on: {
            click: function click($event) {
              return _vm.remove(scope.row, scope.$index);
            }
          }
        }), _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            disabled: _vm.isPreView,
            title: "复制",
            icon: "el-icon-document-copy"
          },
          on: {
            click: function click($event) {
              return _vm.create("copy", scope.row);
            }
          }
        })] : undefined;
      }
    }], null, true)
  }) : _vm._e()], 2), _vm._t("pagination")], 2) : _vm._e()], 2), _vm.template ? _c(_vm.template, {
    tag: "component"
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };